import React from "react";

const ReviewBadge = ({ rating, platform, reviewsCount, isMobile, style }) => {
  const starColor = platform === 'trustpilot' ? '#00b67a' : '#fbbc04';
  const platformLabel = platform === 'trustpilot' ? 'Trustpilot' : 'Google';
  const numericRating = parseFloat(rating) || 0;

  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: '#ffffff',
      padding: isMobile ? '6px 10px' : '10px 16px',
      borderRadius: '6px',
      border: '1px solid #e0e0e0',
      gap: isMobile ? '6px' : '10px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      ...style
    }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ display: 'flex', gap: '2px' }}>
          {[1, 2, 3, 4, 5].map((star) => {
            const fill = Math.min(1, Math.max(0, numericRating - (star - 1)));
            return (
              <svg key={star} width={isMobile ? 14 : 20} height={isMobile ? 14 : 20} viewBox="0 0 24 24">
                <defs>
                  <linearGradient id={`star-fill-${star}`}>
                    <stop offset={`${fill * 100}%`} stopColor={starColor} />
                    <stop offset={`${fill * 100}%`} stopColor="#ddd" />
                  </linearGradient>
                </defs>
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill={`url(#star-fill-${star})`} />
              </svg>
            );
          })}
        </div>
        <span style={{
          fontSize: isMobile ? '11px' : '14px',
          color: '#023a51',
          fontWeight: '600',
          whiteSpace: 'nowrap',
          marginTop: 4
        }}>
          Rated {rating} on {platformLabel}
        </span>
        {reviewsCount && (
          <span style={{
            fontSize: isMobile ? '9px' : '11px',
            color: '#666',
            fontWeight: '400',
            whiteSpace: 'nowrap'
          }}>
            {Number(reviewsCount).toLocaleString()} reviews
          </span>
        )}
      </div>
    </div>
  );
};

export default ReviewBadge;
